import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PlantTable from './plant-table';
import PlantTile from './plant-tile';
import PlantSearch from './plant-search';
import PlantNavBar from './plant-nav-bar';

const PlantContent = props => {
  const [activeLane, setActiveLane] = useState('ALL');
  const tileView = useSelector(state => state.plant?.tileView ?? true);

  return (
    <div className="card table-list-card">
      <div className="card-body">
        <div className="table-top w-100">
          <PlantSearch />
        </div>
        <div className="d-flex">
          <PlantNavBar onLaneChange={setActiveLane} activeLane={activeLane} />
          {!tileView ? <PlantTable activeLane={activeLane} /> : <PlantTile />}
        </div>
      </div>
    </div>
  );
};

export default PlantContent;
